
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/field";
import { Button } from "@/components/ui/button";
import { User, Mail, Phone, Crown } from "lucide-react";
import { cn } from "@/lib/utils";
import { PersonalInfoFormValues } from "./validation/settingsSchema";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";

interface PersonalInfoFormProps {
  form: UseFormReturn<PersonalInfoFormValues>;
  isLoading: boolean;
  userEmail: string; // Add email as a prop
  onSave: (data: PersonalInfoFormValues) => Promise<void>;
  onCancel: () => void;
}

export function PersonalInfoForm({
  form,
  isLoading,
  userEmail, // Use the new prop
  onSave,
  onCancel
}: PersonalInfoFormProps) {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSave)} className="space-y-4">
        <FormField
          control={form.control}
          name="full_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-white/70">Name</FormLabel>
              <div className="flex gap-2 items-center">
                <User className="h-5 w-5 text-white/70" />
                <FormControl>
                  <Input
                    {...field}
                    className="flex-1 bg-white/10 border-white/20 text-white"
                  />
                </FormControl>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="space-y-2">
          <Label className="text-white/70">Email</Label>
          <div className="flex gap-2 items-center">
            <Mail className="h-5 w-5 text-white/70" />
            <Input
              type="email"
              value={userEmail} // Use the email prop directly
              disabled
              className="flex-1 bg-white/10 border-white/20 text-white opacity-50 cursor-not-allowed"
            />
          </div>
        </div>

        <FormField
          control={form.control}
          name="phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-white/70">Phone</FormLabel>
              <div className="flex gap-2 items-center">
                <Phone className="h-5 w-5 text-white/70" />
                <FormControl>
                  <Input
                    {...field}
                    className="flex-1 bg-white/10 border-white/20 text-white"
                  />
                </FormControl>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="specialization"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-white/70">Specialisation</FormLabel>
              <div className="flex gap-2 items-center">
                <Crown className="h-5 w-5 text-white/70" />
                <FormControl>
                  <Input
                    {...field}
                    className="flex-1 bg-white/10 border-white/20 text-white"
                  />
                </FormControl>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex gap-2 pt-4">
          <Button
            type="submit"
            disabled={isLoading}
            variant="purple"
          >
            Save changes
          </Button>
          <Button
            variant="outline"
            onClick={onCancel}
            type="button"
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      </form>
    </Form>
  );
}
